/// <amd-module name="TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Constants" />

export const enum ImagePaths {
    AddDescriptionUpsellPath = "ms.vss-tfs-web/project-overview-content/ProjectOverviewTab/Images/add_description_upsell.svg",
    ProjectOverviewDayZeroImagePath = "ms.vss-tfs-web/project-overview-content/ProjectOverviewTab/Images/project_overview_day_zero.png",
    StatsUpsellPath = "ms.vss-tfs-web/project-overview-content/ProjectOverviewTab/Images/project_stats_upsell.png"
}

export const MaxDescriptionLength = 15999;
export const TfvcPrefix = "$/";
export const WikiHomePage = "WikiHomePage";
export const ProjectScopeName = "project";

export const enum ComponentRegionNames {
    ProjectOverviewLanguagesRegion = "projectOverviewLanguagesRegion",
    StatsRegion = "statsSection",
    ProjectOverviewDayZeroNavRegion = "projectOverviewDayZeroNavRegion"
}

export namespace ProjectTagsConstants {
    export const CharacterLimit = 40;
    export const MaxCount = 15;
    export const Separators = [",", ";"];
    export const PropertyPrefix = "Microsoft.TeamFoundation.Project.Tag.";
}

export const enum AboutProjectScenarios {
    GetAboutProjectData = "AboutProjectSource.GetAboutProjectData",
    GetAllProjectTagsInCollection = "AboutProjectSource.GetAllProjectTagsInCollection",
    SaveDescription = "AboutProjectSource.SaveDescription",
    SaveReadMeSettings = "AboutProjectSource.SaveReadMeSettings",
    SaveProjectTags = "AboutProjectSource.SaveProjectTags"
}

export const enum PermissionsScenarios {
    GetViewActivityPanePermission = "PermissionsSource.GetViewActivityPanePermission"
}

export const enum OverviewTabTelemetryConstants {
    Area = "ProjectOverviewPage_OverviewTab",
    AboutProjectPanel = "AboutProjectPanel",
    DayZero_ManageServiceLink = "ProejctOverview_DayZero_ManageServiceLink",
    DayZero_ServiceNavigationLink = "ProjectOverview_DayZero_ServiceNavigationLink",
    ProjectDescription_Update = "ProjectDescription_Update",
    ProjectReadMeSettings_Update = "ProjectReadMeSettings_Update",
    ProjectStats_NumberOfDaysDropDown = "ProjectStats_NumberOfDaysDropDown",
    ProjectTags_FetchAllProjectTags = "ProjectTags_FetchAllProjectTags",
    ProjectTags_Update = "ProjectTags_Update"
}
